module.exports = __webpack_public_path__ + "img/PL00254.2026b139.svg";